export default __webpack_public_path__ + "static/media/TV1.f67c087e.png";